<template>
  <div class="btn-group bg-white rounded-5" role="group">
    <button
      v-for="filter in filters"
      :key="filter.id"
      class="btn btn-sm border-2 fw-bold"
      @click="setSelectedFilter(filter.id)"
      :class="{
        'btn-secondary': filter.id === selectedFilter,
        'btn-outline-secondary': filter.id !== selectedFilter
      }"
    >
      {{ filter.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ButtonGroup",
  data() {
    return {
      selectedFilter: ""
    };
  },
  emits: ["setSelectedFilter"],
  props: {
    filters: {
      type: Array,
      required: true
    }
  },
  methods: {
    setSelectedFilter(filter) {
      this.selectedFilter = filter;
      this.$emit("setSelectedFilter", filter);
    }
  },
  mounted() {
    this.selectedFilter = this.filters[0].id;
  }
};
</script>

<style scoped>
button {
  padding-right: 15px;
  padding-left: 15px;
  border-radius: 2em 0 0 2em;
}
button:last-child {
  padding-right: 20px;
  border-radius: 0 2em 2em 0;
}
</style>
